import { render, staticRenderFns } from "./OrderGlobalPoints.vue?vue&type=template&id=1d1677c3&scoped=true&"
import script from "./OrderGlobalPoints.vue?vue&type=script&lang=js&"
export * from "./OrderGlobalPoints.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=1d1677c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1677c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1677c3')) {
      api.createRecord('1d1677c3', component.options)
    } else {
      api.reload('1d1677c3', component.options)
    }
    module.hot.accept("./OrderGlobalPoints.vue?vue&type=template&id=1d1677c3&scoped=true&", function () {
      api.rerender('1d1677c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sections/OrderGlobalPoints.vue"
export default component.exports